import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M11 2H13C14.5977 2 15.9037 3.24892 15.9949 4.82373L16 5V6H19C20.6569 6 22 7.34315 22 9V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V9C2 7.34315 3.34315 6 5 6H8V5C8 3.40232 9.24892 2.09634 10.8237 2.00509L11 2H13H11ZM20 16H4V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V16ZM19 8H5C4.44772 8 4 8.44772 4 9V14H20V9C20 8.44772 19.5523 8 19 8ZM13 4H11C10.4872 4 10.0645 4.38604 10.0067 4.88338L10 5V6H14V5C14 4.48716 13.614 4.06449 13.1166 4.00673L13 4Z" />,
  'Suitcase'
);
